﻿
import $ from "jquery";
import { GuiListGeneric } from "../GuiListGeneric";

    export class GuiListAdbTurnus extends GuiListGeneric {
        constructor() {
            super("GuiListAdbTurnus");
        }

        protected attachListEvents() {
            super.attachListEvents();
            $("div.erz-list-element input:checkbox.form-check-input, label.form-check-label").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.clickCheck(e); });
        }

        // ret
        clickCheck(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
            this.log("clickCheck");
            e.stopPropagation();

            const cb = $(e.target).closest("div.form-check").find("input:checkbox");
            const adbid = cb[0].id as string;
            const url = $("div.erz-list").data("select-url");

            const urlSelect = `${url}?adbid=${adbid}`;
            $.get(urlSelect);
        }
    }
